import { getRelativePath } from "base/shared/Utils";

const BASE_PATH = "/recommendations";

export const getRecommendationsPath = ({ roomId } = {}) => {
  const path = roomId ? `${BASE_PATH}/${roomId}` : BASE_PATH;

  return getRelativePath(path);
};
